import { PropTypes } from 'prop-types';
import AccionaIcon from '../AccionaIcon';

const AccionaTableButton = ({
  onClick,
  hidden,
  disabled,
  toolTip,
  type,
  style,
  children,
  className,
}) => {
  const classButtons = {
    verticalAlign: 'initial',
    border: '0px',
    width: '42px',
    height: '36px',
    margin: '0px 2px',
    borderRadius: '3px',
    padding: '0px 12px',
    ...style,
  };

  const getFAClassFromType = () => {
    switch (type) {
      case 'view':
        return 'fas fa-eye';
      case 'delete':
        return 'fas fa-trash-alt';
      case 'csv':
        return 'fas fa-file-csv';
      case 'edit':
        return 'fas fa-pencil-alt';
      case 'details':
        return 'fas fa-file';
      case 'filter':
        return 'fas fa-filter';
      case 'link':
        return 'fas fa-link';
      case 'copy':
        return 'fas fa-copy';
      case 'unBatch':
        return 'fas fa-unlink';
      default:
        return 'fas fa-eye';
    }
  };

  return (
    <AccionaIcon
      style={classButtons}
      className={`btn btn-darkgray ${className}`}
      onClick={onClick}
      hidden={hidden}
      classIcon={`icon ${getFAClassFromType()}`}
      toolTip={toolTip}
      disabled={disabled}
    >
      {children}
    </AccionaIcon>
  );
};

AccionaTableButton.defaultProps = {
  onClick: () => {},
  hidden: false,
  disabled: false,
  toolTip: 'Default action button',
  type: 'view',
  style: {},
  children: undefined,
  className: '',
};

AccionaTableButton.propTypes = {
  onClick: PropTypes.func,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  toolTip: PropTypes.string,
  type: PropTypes.oneOf([
    'view',
    'delete',
    'csv',
    'edit',
    'details',
    'filter',
    'link',
    'copy',
    'unBatch',
  ]),
  style: PropTypes.object,
  children: PropTypes.element,
  className: PropTypes.string,
};

export default AccionaTableButton;
